/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsMagicWand: {
  name: 'magic-wand';
  data: string;
} = {
  name: 'magic-wand',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M15 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm6 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm-5.586 2a2 2 0 0 0-2.828 0l-2.293 2.293L3 17.586a2 2 0 0 0 0 2.828L4.586 22a2 2 0 0 0 2.828 0l7.293-7.293L17 12.414a2 2 0 0 0 0-2.828L15.414 8ZM4.586 22 6 20.586 4.414 19 11 12.414 12.586 14 6 20.586 4.586 22ZM14 12.586 15.586 11 14 9.414 12.414 11 14 12.586ZM12 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm7 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z" fill="currentColor"/></svg>`,
};
